import { render, staticRenderFns } from "./addMajor.vue?vue&type=template&id=1a71cc7a&scoped=true&"
import script from "./addMajor.vue?vue&type=script&lang=js&"
export * from "./addMajor.vue?vue&type=script&lang=js&"
import style0 from "./addMajor.vue?vue&type=style&index=0&id=1a71cc7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a71cc7a",
  null
  
)

export default component.exports